import type { TUNDR_ICONS } from '@tundr/theme-assets/tundr-icons/tundr-icons-icons';

export const DropdownPlacement = {
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left',
  TOP_START: 'top-start',
  TOP_END: 'top-end',
  BOTTOM_START: 'bottom-start',
  BOTTOM_END: 'bottom-end',
  LEFT_START: 'left-start',
  LEFT_END: 'left-end',
  RIGHT_START: 'right-start',
  RIGHT_END: 'right-end',
} as const;

export type DropdownPlacementType =
  (typeof DropdownPlacement)[keyof typeof DropdownPlacement];

export type DropdownProps = {
  modelValue?: string | null;
  triggerIcon?: TUNDR_ICONS;
  /**
   * When true, the popover trigger merges props into the slot's single root (Ark `asChild`).
   * Use with a custom slot trigger that contains interactive elements (e.g. a `button`) to avoid nested buttons.
   */
  triggerAsChild?: boolean;
  /** When true, the slot trigger stretches to 100% width. */
  triggerFullWidth?: boolean;
  withPadding?: boolean;
  fixedHeight?: boolean;
  /**
   * Class on the Popover trigger when using the `#trigger` slot (e.g. reset default `<button>` styles when `triggerAsChild` is false).
   */
  slotTriggerClass?: string;
  disableTeleport?: boolean;
  closeOnInteract?: boolean;
  autoFocus?: boolean;
  initialFocusEl?: () => HTMLElement | null;
  ignoredOutsideSelectors?: string[];
  /** When true, the dropdown cannot be opened and will close if already open. */
  disabled?: boolean;
  /** Accessible name for the trigger, for triggers whose content has no text (e.g. icon-only). */
  triggerAriaLabel?: string;
  /** Controlled open state. When set, use true to open and false to close. */
  open?: boolean;
  placement?: DropdownPlacementType;
  sameWidth?: boolean;
  selfScroll?: boolean;
  testId?: string;
  id?: string;
};

export type DropdownEmits = {
  'update:modelValue': [value: string];
  'update:open': [open: boolean];
};
